<template>
</template>
<script>
    import AlignmentMixin from "../../../author/pagesbuilder/mixins/AlignmentMixin";

    export default {
        name: "HorizontalLineWrapperElement",
        mixins: [
            AlignmentMixin
        ],
        data() {
            return {
                elementType: 'horizontalLineWrapper',
            }
        },
        computed: {
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    linkData: {},
                    responsiveAlignmentClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    itemVisibilitySettings: null
                }
            },
        }
    }
</script>
